export default __webpack_public_path__ + "static/media/icon3.1b579aff.png";